// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"c80b9ad9","379":"194187c7","463":"4c26936c","566":"194187c7","745":"83f3a8ff","971":"194187c7"}[chunkId] + ".chunk.css";
};